import kotlinx.serialization.Serializable

sealed interface AppRoute {
    @Serializable
    data object Gate : AppRoute
    @Serializable
    data class Wonder(val wonderId: String) : AppRoute
    @Serializable
    data object NotInvited : AppRoute
    @Serializable
    data class Gallery(val wonderId: String) : AppRoute
}